/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Ignore_ConfirmInputs */

const vi_reconcile_ignore_confirm = /** @type {(inputs: Reconcile_Ignore_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận bỏ qua`)
};

/**

* @param {Reconcile_Ignore_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_ignore_confirm = /** @type {((inputs?: Reconcile_Ignore_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Ignore_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_ignore_confirm(inputs)
});